import React from 'react'
import tw, { styled } from 'twin.macro';

interface CheckboxProps extends React.HTMLProps<HTMLInputElement> {
  className?: string
  checked?: boolean
}

const Checkbox: React.FC<CheckboxProps> = ({
  className,
  checked,
  ...props
}) => (
  <CheckboxContainer className={className}>
    <HiddenCheckbox type="checkbox" checked={checked} {...props} />
    <StyledCheckbox checked={checked}>
      <Icon viewBox="0 0 24 24">
        <polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>
  </CheckboxContainer>
)

const HiddenCheckbox = styled.input`
border: 0;
clip: rect(0 0 0 0);
clippath: inset(50%);
height: 1px;
margin: -1px;
overflow: hidden;
padding: 0;
position: absolute;
white-space: nowrap;
width: 1px;
`

const Icon = styled.svg`
  fill: none;
  stroke: #E3E833;
  stroke-width: 2px;
`

const StyledCheckbox = styled.div`
  display: inline-block;
  width: 16px;
  height: 16px;
  background: ${(props: any) => (props.checked ? "#A0A0A0" : "#ffffff")};
  border-radius: 3px;
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px #E3E833;
  }
  ${Icon} {
    visibility: ${(props: CheckboxProps) => (props.checked ? "visible" : "hidden")};
  }
`

const CheckboxContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  ${tw`mr-3`}
`

export default Checkbox